import { Component, Prop, Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';

@Component({
  computed: {
    dayjs() {
      return dayjs;
    },
  },
})

export default class DateTimeRangePickerMenu extends Vue {
  @Prop({ default: null })
  public readonly value!: [number, number] | null;

  public isOpen = false;
  public dateTimeString = '';
  public dateTime: [number, number] | null = null;

  public localDateTime = {
    date: [dayjs(new Date()).format('YYYY-MM-DD'), dayjs(new Date()).format('YYYY-MM-DD')],
    time: ['00:00', '23:59'],
  }

  public mounted(): void {
    this.incomeValueChanged();
  }

  public getDateTime = (): [number, number] => {
    let time0 = 0;
    let time1 = 0;
    if (this.localDateTime.time[0]) {
      const [hours0, minutes0] = this.localDateTime.time[0].split(':').map(Number);
      time0 = (hours0 * 3600) + (minutes0 * 60);
    }

    if (this.localDateTime.time[1]) {
      const [hours1, minutes1] = this.localDateTime.time[1].split(':').map(Number);
      time1 = (hours1 * 3600) + (minutes1 * 60);
    }

    const startTimestamp = new Date(this.localDateTime.date[0]).setHours(0, 0, 0, 0) + time0 * 1000;
    const endTimestamp = new Date(this.localDateTime.date[1]).setHours(0, 0, 0, 0) + time1 * 1000;

    return [startTimestamp / 1000, endTimestamp / 1000];
  }

  public incomeValueChanged(): void {
    const dateTime = this.getDateTime();
    this.dateTime = dateTime;
    this.dateTimeString = `${
      dateTime[0] && dayjs(dateTime[0] * 1000).format('HH:mm:ss DD:MM:YYYY')} - ${
      dateTime[1] && dayjs(dateTime[1] * 1000).format('HH:mm:ss DD:MM:YYYY')}`;
    this.$emit('input', this.dateTime);
  }

  public onSubmit = () => {
    const range = this.getDateTime();
    this.$emit('onChanged', range);
  }
}
